var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserSquareSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5v8h16V.5H0v8Zm1.194 0v6.806H2.75l.004-1.501.005-1.501.304-.141c1.088-.506 2.15-.833 3.213-.989a11.82 11.82 0 0 1 3.952.087 11.88 11.88 0 0 1 2.711.902l.304.14.005 1.502.004 1.5H14.806V1.695H1.194V8.5Zm6.569-5.193c-.82.056-1.57.409-2.142 1.006a3.221 3.221 0 0 0-.92 2.282c0 .913.326 1.701.966 2.342.63.63 1.443.966 2.333.966.89 0 1.704-.337 2.333-.966.64-.64.966-1.43.966-2.342 0-.87-.315-1.652-.917-2.278a3.274 3.274 0 0 0-2.619-1.01Zm-.038 1.195c-1.113.14-1.944 1.18-1.83 2.294.05.495.238.908.57 1.256.411.434.938.66 1.535.66 1.512 0 2.525-1.52 1.952-2.928-.352-.866-1.28-1.4-2.227-1.282Zm-.142 7.744a10.349 10.349 0 0 0-3.569.796l-.07.034v2.23h8.113v-2.23l-.071-.034a10.263 10.263 0 0 0-3.123-.769c-.26-.021-1.07-.039-1.28-.027Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    transform: "translate(0 .5)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserSquareSingle);
export default __webpack_public_path__ + "static/media/icon--user-square-single.1736a426d37374d396304cb1e3d7ed19.svg";
export { ForwardRef as ReactComponent };